export enum Role {
  Admin = "ROLE_ADMIN",
  User = "ROLE_MEMBER",
  Secretary = "ROLE_SECRETARY",
  Treasurer = "ROLE_TREASURER",
  AppUser = "ROLE_APP_USER",
  isBankAdmin = "Bank_Admin",
  BranchAdmin = "Bank_Branch_Admin",
  Relationship_Manager = "Relationship_Manager"
}

export enum PermissionModule {
  ROLE_MANAGEMENT = "ROLE_MANAGEMENT",
  ROLE_MANAGEMENT_CHECKER = "ROLE_MANAGEMENT_CHECKER",
  USER_MANAGEMENT = "USER_MANAGEMENT",
  USER_MANAGEMENT_CHECKER = "USER_MANAGEMENT_CHECKER",
  DENOMINATION = "DENOMINATION",
  CHURCH = "CHURCH",
  CHURCH_PROFILE = "CHURCH_PROFILE",
  CHURCH_ADMIN = "CHURCH_ADMIN",
  CARITAS = "CARITAS",
  AUDIT = "AUDIT",
  BRANCH = "BRANCH",
  DASHBOARD = "DASHBOARD",
  OVER_DASHBOARD = "OVER_DASHBOARD"
}

